const Accounts = {
    accountCultureChanged: "accountCultureChanged",
    accountBalanceUpdated: "accountBalanceUpdated",
    accountAddressChanged: "accountAddressChanged",
    accountDetailsChanged: "accountDetailsChanged",
    accountPreferencesChanged: "accountPreferencesChanged",
}

const Sports = {
    gameStarted: "gameStarted",
    gameEnded: "gameEnded",
    gameSummaryDataChanged: "gameSummaryDataChanged",
    //playersGameStatsDataChanged: "playersGameStatsDataChanged"
};

const ECommerce = {
    transferFailed: "transferFailed",
    transferCreated: "transferCreated",
    transferCompleted: "transferCompleted",
    transferCancelled: "transferCancelled",
    addFundsFailed: "addFundsFailed",
    fundsAddedToCustomerAccount: "fundsAddedToCustomerAccount",
    transactionValidationStarted: "transactionValidationStarted",
    accountWithdrawSuccess: "accountWithdrawSuccess",
    accountDebitedSuccess: "accountDebitedSuccess",
    payRetailersTransactionCreated: "payRetailersTransactionCreated",
};

const PickX = {
    contestCompleted: "contestCompleted",
    contestRemoved: "contestRemoved",
    contestsUpdated: "contestsUpdated",
    contestsCreated: "contestsCreated",
    contestStarted: "contestStarted",
    contestCancelled: "contestCancelled",
    contestValuesUpdated: "contestValuesUpdated",
    parlayPlaced: "parlayPlaced",
    placeParlayFailed: "placeParlayFailed",
    parlayCancelled: "parlayCancelled",
    parlayCompleted: "parlayCompleted",
    parlayResultsChanged: "parlayResultsChanged",
    preSelectedParlayChanged: "preSelectedParlayChanged",
    preSelectedParlayCreated: "preSelectedParlayCreated",
    preSelectedParlayDeleted: "preSelectedParlayDeleted",
    preSelectedParlayExpired: "preSelectedParlayExpired",
    preSelectedParlayCancelled: "preSelectedParlayCancelled",
    rollingPrizeActivated: "rollingPrizeActivated",
    rollingPrizeChanged: "rollingPrizeChanged",
    rollingPrizeClosed: "rollingPrizeClosed",
};

const ApiWsEvents = {
    Accounts,
    ECommerce,
    Sports,
    PickX
};
export default ApiWsEvents;